import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import en from "./locales/en.json";
import th from "./locales/th.json";
import ph from "./locales/ph.json";
import vi from "./locales/vi.json";
import km from "./locales/km.json";
import lo from "./locales/lo.json";
import id from "./locales/id.json";
import mm from "./locales/mm.json";
import cn from "./locales/cn.json";
import soc from "./locales/camp.json";
import kr from "./locales/kr.json";

import { getLocalStorage } from "./utils/utils";

i18n
  .use(Backend)
  // .use(LanguageDetector) // OPTIONAL
  .use(initReactI18next)
  .init({
    //  Set default language
    resources: {
      en: {
        translation: en,
      },
      th: {
        translation: th,
      },
      ph: {
        translation: ph,
      },
      vi: {
        translation: vi,
      },
      km: {
        translation: km,
      },
      lo: {
        translation: lo,
      },
      id: {
        translation: id,
      },
      mm: {
        translation: mm,
      },
      cn: {
        translation: cn,
      },
      soc: {
        translation: soc,
      },
      kr: {
        translation: kr,
      },
    },
    lng: getLocalStorage("lang"),
    // lng: "lo",
    fallbackLng: "th",
    debug: false,
    //  string or array of namespaces to load
    ns: "translation",
    //  default namespace used if not passed to 'translation function'
    defaultNS: "translation",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
